module.exports = __webpack_public_path__ + "static/media/bgEtiqaNewV3.a7fdf0a7.png";